import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta'
import App from './App.vue';
import router from './routes.js';
import store from './store';
import AuthService from './services/auth.service';

import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['Authorization'] = `Bearer ${window.localStorage.getItem('access_token')}`;
axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      switch (error.response.status) {
        case 401:
          AuthService.logout();
          vm.$router.push('/');
          break;
        case 400:
          if (error.response.data.url) {
            vm.$router.push(error.response.data.url);
          } else {
            vm.$router.push('/projects');
          }
          break;
        case 409:
          if (error.response.data.reason) {
            setTimeout(() => {
              vm.$toast.add({
                severity: 'error',
                summary: error.response.data.reason,
                life: 3000,
                closable: false
              })
            }, 100);
          }
          if (error.response.data.url) {
            vm.$router.push(error.response.data.url);
          } else {
            vm.$router.push('/projects');
          }
          break;
        case 410:
          if (error.response.data.reason) {
            setTimeout(() => {
              vm.$toast.add({
                severity: 'error',
                summary: error.response.data.reason,
                life: 3000,
                closable: false
              })
            }, 100);
          }
          if (error.response.data.url) {
            vm.$router.push(error.response.data.url);
          } else {
            vm.$router.push('/projects');
          }
          break;
      }

      return Promise.reject(error);
    }
);
Vue.prototype.$http = axios;

import PortalVue from 'portal-vue';
import VueScrollTo from 'vue-scrollto';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import AppLogo from './components/AppLogo';
import AuthenticationMethods from './components/AuthenticationMethods';
import Icon from './components/Icon';
import NewProjectSearch from './components/NewProjectSearch';
import StepsProgress from './components/StepsProgress';
import ProgressSpinner from './components/ProgressSpinner';

import './prime';
import './css/app.css';
import KeyboardEvents from "./components/KeyboardEvents.vue";

Vue.config.productionTip = false

Vue.component('app-logo', AppLogo);
Vue.component('authentication-methods', AuthenticationMethods);
Vue.component('keyboard-events', KeyboardEvents);
Vue.component('icon', Icon);
Vue.component('new-project-search', NewProjectSearch);
Vue.component('progress-spinner', ProgressSpinner);
Vue.component('steps-progress', StepsProgress);

Vue.filter('splitNumber', function (value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
})

Vue.use(PrimeVue);
Vue.use(ToastService);
Vue.use(PortalVue);
Vue.use(VueScrollTo);
Vue.use(VueRouter);
Vue.use(VueMeta);

Vue.mixin({
  methods: {
    processAxiosPositiveResponse: function (data) {
      if (data.toast) {
        this.$toast.add({
          severity: data.toastType || 'success',
          summary: data.toast,
          life: 3000,
          closable: false
        })
      }
    },
    showToast(message, severity, time) {
      this.$toast.add({
        severity: severity || 'success',
        summary: message,
        life: time || 3000,
        closable: false
      })
    },
  },
})

import VueGtm from '@gtm-support/vue2-gtm';
Vue.use(VueGtm, {
  enabled: process.env.NODE_ENV !== 'local', // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  /*queryParams: {
    // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    gtm_preview: 'env-4',
    gtm_cookies_win: 'x',
  },*/
  id: process.env.VUE_APP_GTM_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  //nonce: '', // Will add `nonce` to the script tag
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  debug: process.env.NODE_ENV !== 'production', // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

export let vm;
vm = new Vue({
  render: h => h(App),
  router,
  store,
  data() {
    return {
      isMobile: false,
      et: {
        firstDayOfWeek: 1,
        dayNames: ['Pühapäev', 'Esmaspäev', 'Teisipäev', 'Kolmapäev', 'Neljapäev', 'Reede', 'Laupäev'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
        monthNames: [
          'Jaanuar',
          'Veebruar',
          'Märts',
          'Aprill',
          'Mai',
          'Juuni',
          'Juuli',
          'August',
          'September',
          'Oktoober',
          'November',
          'Detsember'
        ],
        monthNamesShort: [
          'Jaanuar',
          'Veebruar',
          'Märts',
          'Aprill',
          'Mai',
          'Juuni',
          'Juuli',
          'August',
          'September',
          'Oktoober',
          'November',
          'Detsember'
        ],
        today: 'Täna',
        clear: 'Tühista',
        dateFormat: 'dd.mm.yy',
        weekHeader: 'Nädal'
      }
    }
  },
  mounted() {
    this.detectMobile()
  },
  methods: {
    detectMobile() {
      if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
              navigator.userAgent
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
              navigator.userAgent.substr(0, 4)
          )
      ) {
        this.isMobile = true
      }
    }
  },
}).$mount('#app');
